import { API } from '@/config/api.js'

export default {
  namespaced: true,
  state: () => ({
  	loading: false,
    error: null,
  }),
  getters: {
  },
  mutations: {
  	SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, value) {
      state.error = value
    },
  },
  actions: {
    async SEND_REQUEST({ commit, dispatch, state }, data) {
    	let payload = {...data}
    	try {
        const res = await fetch(`${API.fullUrl}/landing/send-request`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        // обработка ошибок сразу
        if (!res.ok) {
          const { message } = await res.json().catch(() => ({}))
          const errorMsg = message || 'Ошибка авторизации'
          commit('SET_ERROR', errorMsg)
          throw new Error(errorMsg)
        }
        
        return data
      } catch (err) {
        commit('SET_ERROR', err.message || 'Неизвестная ошибка')
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
